import { render } from "./FormatLA.vue?vue&type=template&id=42dcad0e&scoped=true"
import script from "./FormatLA.vue?vue&type=script&lang=js"
export * from "./FormatLA.vue?vue&type=script&lang=js"

import "./FormatLA.vue?vue&type=style&index=0&id=42dcad0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dcad0e"]])

export default __exports__